import Vue from 'vue'
import Component from 'vue-class-component'
import authStore from '@/store/auth/auth-store'
import NonAuthHeader from '@/components/NonAuthHeader';

@Component({
  name: 'callback',
  components: {
    'non-auth-header': NonAuthHeader
  }
})
export default class Callback extends Vue {
  mounted (): void {
    authStore.dispatchAuthCallback().then((state: { page: string, id: string|null|undefined, uid: string|null|undefined } | null) => {
      if (state) {
        // console.log('Callback: query = %j', state.query)
        let query
        if (state.id) query = {id: state.id}
        else if (state.uid) query = {uid: state.uid}
        else query = {}
        this.$router.push ({
          path: `/${state.page ? state.page : ''}`,
          query: query
        })
      } else {
        this.$router.push ({
          path: '/about'
        })
      }
    })
  }
}
